import React from "react";

/**
 * Renders an embed for aerial (drone) videos or Google Street View / Maps.
 * Supported inputs:
 *  - YouTube: https://www.youtube.com/watch?v=ID, https://youtu.be/ID
 *  - Vimeo: https://vimeo.com/ID
 *  - Google Maps / Street View embed src (from "Share > Embed a map"):
 *      https://www.google.com/maps/embed?pb=...
 *  - Google Maps place URL: https://www.google.com/maps/place/...
 *    (will be wrapped into an iframe as-is with output=embed)
 */
export default function DroneEmbed({ url, title = "Vista aérea", className = "" }) {
  if (!url) return null;
  const clean = url.trim();
  let src = null;

  const yt1 = clean.match(/youtube\.com\/watch\?v=([\w-]+)/);
  const yt2 = clean.match(/youtu\.be\/([\w-]+)/);
  const yt3 = clean.match(/youtube\.com\/embed\/([\w-]+)/);
  const vim = clean.match(/vimeo\.com\/(\d+)/);

  if (yt1) src = `https://www.youtube.com/embed/${yt1[1]}`;
  else if (yt2) src = `https://www.youtube.com/embed/${yt2[1]}`;
  else if (yt3) src = clean;
  else if (vim) src = `https://player.vimeo.com/video/${vim[1]}`;
  else if (/google\.[a-z.]+\/maps\/embed/i.test(clean)) src = clean;
  else if (/google\.[a-z.]+\/maps/i.test(clean)) {
    // Fallback: append output=embed if not present
    src = clean.includes("output=embed") ? clean : `${clean}${clean.includes("?") ? "&" : "?"}output=embed`;
  }

  if (!src) return null;

  return (
    <div
      className={`relative w-full overflow-hidden rounded-2xl bg-stone-900 ${className}`}
      style={{ aspectRatio: "16 / 9" }}
      data-testid="drone-embed"
    >
      <iframe
        src={src}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute inset-0 h-full w-full border-0"
      />
    </div>
  );
}
